module.exports = __webpack_public_path__ + "img/clinicarx-logo-green.710c4414.svg";